export default "__VITE_ASSET__Conb_mPz__"